import React from 'react';
import { Container, Accordion } from 'react-bootstrap';
import '../../style/LandingPageStyle.css';
import Header from './Header'; // Ajustado para o teu caminho correto
import Footer from './footer'; // Ajustado para o teu caminho correto

const FAQPage = () => {
    return (
        <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <Header />
            
            {/* O "flex-grow: 1" garante que o Footer vai para o fundo da página */}
            <div style={{ flexGrow: 1, paddingTop: '120px', paddingBottom: '60px' }}>
                <Container 
                    className='faq-container' 
                    style={{ 
                        backgroundColor: 'white', 
                        padding: '40px', 
                        borderRadius: '12px', 
                        boxShadow: '0 4px 15px rgba(0,0,0,0.05)', 
                        maxWidth: '900px', // Limita a largura para não ficar esticado demais
                        margin: '0 auto', // Centra a caixa no ecrã
                        display: 'block' // FORÇA O LAYOUT A NÃO FICAR LADO A LADO
                    }}
                >
                    <h2 style={{ textAlign: 'center', marginBottom: '50px', color: '#009fe3', fontWeight: 'bold', fontSize: '2.5rem' }}>
                        Perguntas Frequentes (FAQs)
                    </h2>

                    {/* --- SECÇÃO 1: ESTUDANTES E ENGENHEIROS --- */}
                    <div style={{ marginBottom: '50px' }}>
                        <h3 style={{ color: '#009fe3', marginBottom: '25px', borderBottom: '2px solid #009fe3', paddingBottom: '10px', fontSize: '1.5rem', display: 'block' }}>
                            Para Estudantes e Engenheiros Voluntários
                        </h3>

                        {/* Removi o defaultActiveKey="0" para começarem todas fechadas */}
                        <Accordion>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>Quem pode participar como voluntário?</Accordion.Header>
                                <Accordion.Body>
                                    Podem participar:
                                    <ul>
                                        <li>estudantes do ensino superior em áreas de engenharia, tecnologia ou afins;</li>
                                        <li>engenheiros e outros profissionais com competências técnicas relevantes.</li>
                                    </ul>
                                    A participação é voluntária e não remunerada.
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="1">
                                <Accordion.Header>Preciso de ter muita experiência para participar?</Accordion.Header>
                                <Accordion.Body>
                                    Não. Alguns projetos exigem mais experiência, outros são adequados a quem está em início do seu percurso.
                                    <br /><br />
                                    Cada desafio indica:
                                    <ul>
                                        <li>competências desejadas,</li>
                                        <li>nível de complexidade,</li>
                                        <li>esforço estimado.</li>
                                    </ul>
                                    A equipa forma-se com base no equilíbrio entre competências disponíveis e necessidades do projeto.
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="2">
                                <Accordion.Header>Quanto tempo tenho de dedicar?</Accordion.Header>
                                <Accordion.Body>
                                    Depende do projeto. Cada desafio indica a duração estimada e o esforço semanal aproximado.
                                    <br /><br />
                                    A maioria dos projetos é pensada para ser compatível com participação parcial, mas exige compromisso e comunicação regular.
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="3">
                                <Accordion.Header>Posso escolher em que projetos participo?</Accordion.Header>
                                <Accordion.Body>
                                    Sim. Podes candidatar-te apenas aos projetos que te interessam e indicar áreas técnicas e disponibilidade.
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="4">
                                <Accordion.Header>Posso sair de um projeto a meio?</Accordion.Header>
                                <Accordion.Body>
                                    Idealmente não, pois o compromisso é importante. No entanto, compreendemos que podem surgir imprevistos.
                                    <br /><br />
                                    Pedimos que comuniques o mais cedo possível e colabores na transição do trabalho sempre que possível.
                                    A consistência e a conclusão de projetos são valorizadas no perfil.
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="5">
                                <Accordion.Header>O meu trabalho é reconhecido?</Accordion.Header>
                                <Accordion.Body>
                                    Sim. Na app, cada participante pode ver projetos concluídos, horas contributivas, avaliações e impacto gerado.
                                    <br /><br />
                                    Este registo pode ser usado como experiência prática, portefólio ou complemento curricular.
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="6">
                                <Accordion.Header>Posso usar o projeto no meu portefólio ou CV?</Accordion.Header>
                                <Accordion.Body>
                                    Regra geral, sim. Desde que respeites a confidencialidade acordada com a associação e não partilhes dados sensíveis.
                                    Alguns projetos podem ter restrições específicas.
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="7">
                                <Accordion.Header>O Engenheiros4IU garante resultados ou certificações?</Accordion.Header>
                                <Accordion.Body>
                                    Não. O Engenheiros4IU é uma plataforma de mediação e não garante resultados técnicos específicos, certificações formais ou validação académica.
                                    <br /><br />
                                    O valor está na experiência prática e no impacto social.
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>

                    {/* --- SECÇÃO 2: ASSOCIAÇÕES --- */}
                    <div style={{ marginBottom: '40px' }}>
                        <h3 style={{ color: '#009fe3', marginBottom: '25px', borderBottom: '2px solid #009fe3', paddingBottom: '10px', fontSize: '1.5rem', display: 'block' }}>
                            Para Associações e Organizações Sociais
                        </h3>

                        <Accordion>
                            <Accordion.Item eventKey="8">
                                <Accordion.Header>Que organizações podem submeter desafios?</Accordion.Header>
                                <Accordion.Body>
                                    Podem submeter desafios:
                                    <ul>
                                        <li>associações sem fins lucrativos;</li>
                                        <li>IPSS e fundações;</li>
                                        <li>organizações da economia social;</li>
                                        <li>entidades públicas ou comunitárias sem fins lucrativos.</li>
                                    </ul>
                                    Pode ser solicitado comprovativo do estatuto jurídico.
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="9">
                                <Accordion.Header>O Engenheiros4IU trabalha com entidades com fins lucrativos?</Accordion.Header>
                                <Accordion.Body>
                                    Não. A plataforma destina-se exclusivamente a organizações sem fins lucrativos ou de interesse público.
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="10">
                                <Accordion.Header>Que tipo de desafios posso submeter?</Accordion.Header>
                                <Accordion.Body>
                                    Desafios técnicos compatíveis com trabalho voluntário, tais como:
                                    <ul>
                                        <li>apoio em engenharia ou tecnologia;</li>
                                        <li>digitalização de processos;</li>
                                        <li>desenvolvimento de ferramentas simples;</li>
                                        <li>análise, planeamento ou otimização técnica.</li>
                                    </ul>
                                    Projetos excessivamente complexos, críticos ou urgentes podem não ser adequados.
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="11">
                                <Accordion.Header>O serviço tem custos?</Accordion.Header>
                                <Accordion.Body>
                                    Não. O apoio prestado através do Engenheiros4IU é voluntário e gratuito para as associações.
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="12">
                                <Accordion.Header>Quem é responsável pelo resultado final?</Accordion.Header>
                                <Accordion.Body>
                                    Os projetos são desenvolvidos por voluntários, no seu tempo disponível.
                                    <br /><br />
                                    O Engenheiros4IU facilita o contacto e a colaboração, não garante resultados específicos e não assume responsabilidade legal pelas entregas.
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="13">
                                <Accordion.Header>Como é feita a entrega do projeto?</Accordion.Header>
                                <Accordion.Body>
                                    No final, o trabalho é documentado e os ficheiros e materiais são entregues à associação.
                                    A utilização e manutenção da solução passam a ser da responsabilidade da organização.
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="14">
                                <Accordion.Header>O que é esperado da associação durante o projeto?</Accordion.Header>
                                <Accordion.Body>
                                    É essencial que a associação indique uma pessoa de contacto, responda a dúvidas, valide decisões e acompanhe minimamente o progresso.
                                    Projetos com maior envolvimento da associação tendem a ter melhores resultados.
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="15">
                                <Accordion.Header>O que acontece se o projeto não for concluído?</Accordion.Header>
                                <Accordion.Body>
                                    Apesar de todos os esforços, projetos voluntários podem enfrentar obstáculos.
                                    <br /><br />
                                    Se o projeto não for concluído, o trabalho realizado até ao momento é entregue e a experiência contribui para aprendizagem.
                                    O Engenheiros4IU não assume responsabilidade contratual.
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="16">
                                <Accordion.Header>Os dados e informações da associação são confidenciais?</Accordion.Header>
                                <Accordion.Body>
                                    Sim. Os participantes comprometem-se a respeitar a confidencialidade.
                                    Se necessário, podem ser acordadas regras adicionais para dados sensíveis.
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="17">
                                <Accordion.Header>O projeto pode ser divulgado publicamente?</Accordion.Header>
                                <Accordion.Body>
                                    A divulgação de projetos concluídos (texto, imagens, testemunhos) só é feita com consentimento da associação.
                                    É possível anonimizar o nome da organização ou omitir detalhes sensíveis.
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>

                    {/* --- NOTA DE TRANSPARÊNCIA --- */}
                    <div style={{ backgroundColor: '#f0f8ff', padding: '20px', borderRadius: '8px', borderLeft: '4px solid #009fe3', marginTop: '40px', display: 'block' }}>
                        <p style={{ margin: 0, fontStyle: 'italic', fontSize: '0.95rem', color: '#333' }}>
                            <strong>Nota de transparência:</strong> O Engenheiros4IU é uma plataforma de colaboração voluntária.
                            Não substitui serviços profissionais contratados nem cria obrigações laborais ou contratuais.
                        </p>
                    </div>

                </Container>
            </div>
            
            <Footer />
        </div>
    );
};

export default FAQPage;
